module.exports = __webpack_public_path__ + "static/jorisvoorn_3-fcfe974357b71077651be5c2efd9f8e7.jpg";